import { InputNumber, Table } from 'antd';
import Column from 'antd/es/table/Column';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import { formatVND } from '../../helpers/common';
import { ChiTietLuongBoSungTruongBKSItem } from '../../models/luong/LuongBoSungTruongBKS';

interface Props {
    loading: boolean;
    dataSource: ChiTietLuongBoSungTruongBKSItem[];
    isEdit?: boolean;
    onChangeItem?: (index: number, field: string, value: any) => void;
    loai?: number;
}

const TableChiTietLuongBoSungTruongBKS = ({ loading, dataSource, isEdit, onChangeItem, loai }: Props) => {
    const isDieuChinhOrQuyetToan = loai === 1 || loai === 2;

    const getLabelQuyLuong = () => {
        return 'Mức tiền lương/tháng được tạm ứng ';
    };

    return (
        <Table
            sticky
            pagination={false}
            loading={loading}
            bordered
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'Không có dữ liệu' }}
            dataSource={(dataSource || []).map((x, idx) => ({ ...x, key: idx }))}
            summary={(pageData) => {
                const tongQuyLuong = pageData.reduce((s, x) => s + (x.quyLuong ?? x.soTienDuocTamUng ?? 0), 0);
                const tongMucTamUng = pageData.reduce((s, x) => s + (x.mucTamUngMotThang ?? 0), 0);
                const tongSoTienDuocTamUng = pageData.reduce((s, x) => s + (x.soTienDuocTamUng ?? 0), 0);
                const tongSoTienDaTamUng = pageData.reduce((s, x) => s + (x.soTienDaTamUng ?? 0), 0);
                const tongLcb = pageData.reduce((s, x) => s + (x.luongCoBanDaChi ?? 0), 0);
                const tongLbs = pageData.reduce((s, x) => s + (x.luongBoSungDaChi ?? 0), 0);
                const tongConNhan = pageData.reduce((s, x) => s + (x.soTienDuocNhan ?? 0), 0);

                return (
                    <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={3} fixed="left">
                            <b>Tổng cộng</b>
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={1} align="right">
                            <b>{formatVND(tongQuyLuong)}</b>
                        </Table.Summary.Cell>

                        {loai === 1 ? (
                            <>
                                <Table.Summary.Cell index={2} align="right" />
                                <Table.Summary.Cell index={3} align="right">
                                    <b>{formatVND(tongMucTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={4} align="right" />
                                <Table.Summary.Cell index={5} align="right">
                                    <b>{formatVND(tongSoTienDuocTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={6} align="right">
                                    <b>{formatVND(tongSoTienDaTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={7} align="right">
                                    <b>{formatVND(tongLcb)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={8} align="right">
                                    <b>{formatVND(tongLbs)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={9} align="right">
                                    <b>{formatVND(tongConNhan)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={10} align="center" />
                            </>
                        ) : loai === 2 ? (
                            <>
                                <Table.Summary.Cell index={2} align="right" />
                                <Table.Summary.Cell index={3} align="right">
                                    <b>{formatVND(tongSoTienDuocTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={4} align="right">
                                    <b>{formatVND(tongSoTienDaTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={5} align="right">
                                    <b>{formatVND(tongLcb)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={6} align="right">
                                    <b>{formatVND(tongLbs)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={7} align="right">
                                    <b>{formatVND(tongConNhan)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={8} align="center" />
                            </>
                        ) : (
                            <>
                                <Table.Summary.Cell index={2} align="right">
                                    <b>{formatVND(tongSoTienDaTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} align="right">
                                    <b>{formatVND(tongConNhan)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={4} align="right">
                                    <b>{formatVND(tongSoTienDaTamUng)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={5} align="right">
                                    <b>{formatVND(tongConNhan)}</b>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={6} align="center" />
                            </>
                        )}
                    </Table.Summary.Row>
                );
            }}
        >
            <Column title="TT" width={50} fixed="left" align="center" render={(_v, _r, index) => index + 1} />
            <Column title="Họ và tên" dataIndex="hoTen" width={200} fixed="left" />
            <Column title="Chức vụ" dataIndex="tenChucVu" width={140} />

            {/* (1) Mức tiền lương/tháng kế hoạch được duyệt hoặc tương ứng */}
            <Column
                title={getLabelQuyLuong()}
                dataIndex="quyLuong"
                width={160}
                align="right"
                render={(value, record: any) => formatVND(value ?? record.soTienDuocTamUng ?? 0)}
            />

            {loai === 1 && (
                <Column
                    title="Tỷ lệ tạm ứng (%)"
                    dataIndex="tyLeTamUng"
                    width={110}
                    align="right"
                    render={(value, _record, index) =>
                        isEdit ? (
                            <InputNumber
                                min={0}
                                max={100}
                                value={value}
                                style={{ width: '100%' }}
                                onChange={(val) => onChangeItem && onChangeItem(index, 'tyLeTamUng', Number(val) || 0)}
                            />
                        ) : (
                            (value ?? 100) + '%'
                        )
                    }
                />
            )}

            {loai === 1 && (
                <Column
                    title="Mức tiền lương tạm ứng"
                    dataIndex="mucTamUngMotThang"
                    width={150}
                    align="right"
                    render={formatVND}
                />
            )}

            {isDieuChinhOrQuyetToan && (
                <Column
                    title="Số tháng làm việc"
                    dataIndex="soThangLamViec"
                    width={110}
                    align="right"
                    render={(value, _record, index) =>
                        isEdit ? (
                            <InputNumber
                                min={0}
                                max={12}
                                step={0.5}
                                value={value}
                                style={{ width: '100%' }}
                                onChange={(val) => onChangeItem && onChangeItem(index, 'soThangLamViec', Number(val) || 0)}
                            />
                        ) : (
                            value ?? 0
                        )
                    }
                />
            )}

            {/* (5) Tiền lương được nhận */}
            {isDieuChinhOrQuyetToan &&
                <Column
                    title={"Tiền lương được nhận"}
                    dataIndex="soTienDuocTamUng"
                    width={150}
                    align="right"
                    render={formatVND}
                />
            }

            {!isDieuChinhOrQuyetToan && (
                <ColumnGroup title="Trong đó">
                    <Column
                        title="Lương cơ bản đã chi"
                        dataIndex="soTienDaTamUng"
                        width={150}
                        align="right"
                        render={formatVND}
                    />
                    <Column
                        title="Lương bổ sung"
                        dataIndex="soTienDuocNhan"
                        width={150}
                        align="right"
                        render={formatVND}
                    />
                </ColumnGroup>
            )}

            {/* (6) Tiền lương đã nhận */}
            <Column
                title={isDieuChinhOrQuyetToan ? "Tiền lương đã nhận" : "Lương đã tạm ứng"}
                dataIndex="soTienDaTamUng"
                width={150}
                align="right"
                render={formatVND}
            />

            {/* Group Trong đó: (6a) Lương cơ bản đã chi & (6b) Lương bổ sung */}
            {isDieuChinhOrQuyetToan && (
                <ColumnGroup title="Trong đó">
                    <Column
                        title="Lương cơ bản đã chi"
                        dataIndex="luongCoBanDaChi"
                        width={150}
                        align="right"
                        render={formatVND}
                    />
                    <Column
                        title="Lương bổ sung"
                        dataIndex="luongBoSungDaChi"
                        width={150}
                        align="right"
                        render={formatVND}
                    />
                </ColumnGroup>
            )}

            {/* (7) Tiền lương còn được nhận */}
            <Column
                title="Tiền lương còn được nhận"
                dataIndex="soTienDuocNhan"
                width={150}
                align="right"
                render={(value, record: any, index) =>
                    isEdit && !isDieuChinhOrQuyetToan ? (
                        <InputNumber
                            min={0}
                            step={1000}
                            value={value}
                            style={{ width: '100%' }}
                            formatter={(val) => `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(val) => Number(`${val}`.replace(/,/g, '')) || 0}
                            onChange={(val) => onChangeItem && onChangeItem(index, 'soTienDuocNhan', Number(val) || 0)}
                        />
                    ) : (
                        formatVND(value ?? 0)
                    )
                }
            />

            <Column title="Ghi chú" dataIndex="ghiChu" width={150} align="center" />
        </Table>
    );
};

export default TableChiTietLuongBoSungTruongBKS;
